<template>
	<div class="myuser">
		<div class="vx-col md:w-3/6 w-full mb-base form">
			<!-- <p style="font-weight: 700;font-size: 16px;line-height: 50px;color:#000000">我的信息：</p> -->
			<el-form ref="form" :model="users" label-width="80px" v-if="users">
			  <el-form-item>
			    <el-image style="width: 100px; height: 100px" :src="users.headPortrait" :preview-src-list="users.headPortrait?users.headPortrait.split(','):[]"></el-image>
			  </el-form-item>
			  <el-form-item label="姓名">
			    <el-input v-model="users.name" disabled=""></el-input>
			  </el-form-item>
			  <el-form-item label="性别">
			    <el-select v-model="users.sex" placeholder="性别" disabled>
				  <el-option label="未知" :value="0"></el-option>
			      <el-option label="男" :value="1"></el-option>
			      <el-option label="女" :value="2"></el-option>
			    </el-select>
			  </el-form-item>
			  <el-form-item label="手机号">
			    <el-input v-model="users.phone" maxlength="11" disabled=""></el-input>
			  </el-form-item>
			  <el-form-item label="邮箱">
			    <el-input v-model="users.email" maxlength="11" disabled=""></el-input>
			  </el-form-item>
			  <el-form-item label="创建时间">
			     <p>{{users.createTime}}</p>
			  </el-form-item>
			  <el-form-item label="微信绑定">
			     <p v-if="users.wechatAuth">已绑定</p><a v-if="!users.wechatAuth" href="https://h5.culture.ggyzkj.com" target="_blank">去绑定</a>
			  </el-form-item>
			  <el-form-item label="修改密码">
			     <a href="#" @click="editpass">去修改</a>
			  </el-form-item>
			  <!-- <el-form-item>
			    <el-button type="primary" @click="onSubmit">保存</el-button>
			  </el-form-item> -->
			</el-form>
		</div>
		<div class="vx-col md:w-3/6 w-full mb-base form">
			<el-descriptions title="其他信息:" :column="1">
			    <el-descriptions-item label="所属部门" v-if="config.deptNames.length>0"><span v-for="(item,index) in config.deptNames" :key="index">{{item}}</span></el-descriptions-item>
				<el-descriptions-item label="所属部门" v-else>待分配</el-descriptions-item>
			    <el-descriptions-item label="文化考核使用标准">{{config.templateName||'待分配'}}</el-descriptions-item>
			    <el-descriptions-item label="文化考核审核员" v-if="config.reviewerNames.length>0">
			      <el-tag size="small" v-for="(item,index) in config.reviewerNames" :key="index" class="mr-4">{{item}}</el-tag>
			    </el-descriptions-item>
				<el-descriptions-item label="审核员" v-else>
				  <el-tag size="small">待分配</el-tag>
				</el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="code">
			<el-dialog
			  :close-on-click-modal="false"
			  title="修改密码"
			  :visible.sync="centerDialogVisible"
			  width="30%"
			  center>
			  <el-form :model="edit"  label-width="100px" class="demo-dynamic">
				<el-form-item label="手机号" class="formbtn">
				  <el-input :value="users.phone" :disabled="true"></el-input>
				</el-form-item>
			    <el-form-item label="验证码" class="formbtn">
			      <el-input v-model="edit.code"><el-button style="padding-right:10px" slot="suffix" type="text" @click="sendcode">发送验证码</el-button></el-input>
			    </el-form-item>
			    <el-form-item label="新密码">
			      <el-input v-model="edit.password"></el-input>
			    </el-form-item>
			  </el-form>
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="centerDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="savepass">确 定</el-button>
			  </span>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	export default {
	    data() {
	        return {
				users:'',
				centerDialogVisible:false,
				edit:{code:'',password:''},
				config:{reviewerNames:[],deptNames:[]},
			}
	    },
		mounted() {
			this.users = this.$store.state.AppActiveUser;
			this.getconfig();
		},
		methods:{
			getconfig(){
				var that=this;
				this.$api.getdistributioninfo({}).then(function (response) {
					if(response.code==0){
						that.config=response.data;
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				})
			},
			editpass(){   //修改密码
				this.centerDialogVisible=true;
				this.edit={code:'',password:''};
			},
			sendcode(){   //发送验证码
				console.log("发送验证码");
				this.$api.getphonecode({phone:this.users.phone}).then(res=>{
					console.log("验证码发送",res);
					if(res.code==0){
						this.$vs.notify({
						  color:'success',
						  title:'提示',
						  text:"手机验证码已发送"
						})
					}else{
						this.$vs.notify({
						  color:'warning',
						  title:'提示',
						  text:res.message
						})
					}
				}).catch(err=>{console.log("网络错误",err)})
			},
			savepass(){  //保存修改
				if(this.edit.code==''||this.edit.password==''){
					this.$vs.notify({
					  color:'warning',
					  title:'提示',
					  text:"参数错误"
					})
					return false;
				}
				this.$api.Editpass({phone:this.users.phone,code:this.edit.code,password:this.edit.password}).then(res=>{
					if(res.code==0){
						this.$vs.notify({
						  color:'success',
						  title:'提示',
						  text:"修改成功，请重新登录"
						})
						localStorage.clear();
						this.$router.push('/pages/login')
					}else{
						this.$vs.notify({
						  color:'warning',
						  title:'提示',
						  text:res.message
						})
					}
				}).catch(err=>{console.log("网络错误",err)})
			},
		},
	}
</script>
<style type="text/css" scoped="">
	.myuser{
		margin: 30px;
		padding: 30px;
		background-color: #FFFFFF;
	}
	.myuser .myinfo{
		margin-top: 20px;
		min-height: 70vh;
		background-color: #FFFFFF;
		padding: 20px 30%;
	}
</style>
